export interface CurrencyInfo {
  symbol: string;
  rate: number;
  code: string;
}

// Exchange rates - CZK is base currency, others convert FROM CZK
const EXCHANGE_RATES = {
  CZK_TO_EUR: 1 / 24,  // 1 CZK = 0.042 EUR
  CZK_TO_USD: 1 / 19,  // 1 CZK = 0.053 USD
  CZK_TO_CZK: 1.0      // 1 CZK = 1 CZK
};

export const getCurrencyByLocale = (locale: string): CurrencyInfo => {
  switch (locale) {
    case 'cz':
      return { 
        symbol: 'Kč', 
        rate: EXCHANGE_RATES.CZK_TO_CZK,
        code: 'CZK'
      };
    case 'sk':
    case 'de':
      return { 
        symbol: '€', 
        rate: EXCHANGE_RATES.CZK_TO_EUR,
        code: 'EUR'
      };
    case 'en':
      return { 
        symbol: '$', 
        rate: EXCHANGE_RATES.CZK_TO_USD,
        code: 'USD'
      };
    default:
      return { 
        symbol: 'Kč', 
        rate: EXCHANGE_RATES.CZK_TO_CZK,
        code: 'CZK'
      };
  }
};

export const formatPrice = (priceCZK: number, locale: string): string => {
  const currency = getCurrencyByLocale(locale);
  const convertedPrice = Math.round(priceCZK * currency.rate);
  
  // Format number with space as thousands separator for all currencies
  const formattedNumber = convertedPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  
  return `${formattedNumber} ${currency.symbol}`;
};

// Function to update exchange rates (can be called periodically)
export const updateExchangeRates = async (): Promise<void> => {
  try {
    // In a real application, you would fetch from an API like:
    // const response = await fetch('https://api.exchangerate-api.com/v4/latest/EUR');
    // const data = await response.json();
    // Update EXCHANGE_RATES with real data
    
    console.log('Exchange rates updated');
  } catch (error) {
    console.error('Failed to update exchange rates:', error);
  }
};